/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moving_Cozy_Cat_BlendInputs */

const fr_moving_cozy_cat_blend = /** @type {(inputs: Moving_Cozy_Cat_BlendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir supprimer ce programme ?`)
};

/**

* @param {Moving_Cozy_Cat_BlendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const moving_cozy_cat_blend = /** @type {((inputs?: Moving_Cozy_Cat_BlendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moving_Cozy_Cat_BlendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_moving_cozy_cat_blend(inputs)
});